module.exports = __webpack_public_path__ + "img/arrow-up-white-thin.50b8e084.svg";